import React from 'react';
import { initSentry } from '@anyroad/sentry';
import { wrapAllComponents } from 'lib/withIntl';

window.React = React;
window.ReactDOM = require('react-dom');

initSentry({ application: 'resource_portal' });

const ResourcePortal = require('views/resource_portal').default;

window.Views = wrapAllComponents({
  ResourcePortal,
});
